import { Box, Collapse, IconButton, Typography, useTheme } from '@mui/material';
import TypeNumber from '../../form/form-fields/TypeNumber';
import MoneyLabel from '../../label/MoneyLabel';
import { useEffect, useState } from 'react';
import { tokens } from '../../../global/theme/tokens';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const HOAIPhase = ({
  updateValidationOnChange,
  togglePhase,
  phase,
  phaseNumber,
  baseHonorarium,
  showSiemon,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  //const field = { label: "test", key: "phaseCheckbox" };

  const [isCrossed, setIsCrossed] = useState(phase.isCrossed || false);
  const [open, setOpen] = useState(false);

  const key = `${phaseNumber}_phase%`;

  useEffect(() => {
    setDataCollection({
      [key]: phase.value ?? phase.maxPercent,
    });
    if (phase.isCrossed) setIsCrossed(true);
  }, [phase]);

  const [dataCollection, setDataCollection] = useState({
    [key]: phase.value ?? phase.maxPercent,
  });

  const value = phase.value ?? phase.maxPercent;
  const phaseHonorarium =
    Math.round((100 * baseHonorarium * Number(value)) / 100) / 100;

  function handleChange(key, value) {
    /*if (value < 0) {
      setDataCollection({ [key]: 0 });
      updateValidationOnChange(key, 0);
    } else if (value > 100) {
      setDataCollection({ [key]: 100 });
      updateValidationOnChange(key, 100);
    } else {
      updateValidationOnChange(key, value);
      setDataCollection({ [key]: value });
    }*/
    updateValidationOnChange(key, value);
    setDataCollection({ [key]: value });
  }

  function handleSiemonChange(siemonKey, siemonValue) {
    const siemonPhaseId = parseInt(siemonKey);
    let newSiemonPhases = [...phase.siemon];
    newSiemonPhases[siemonPhaseId] = {
      ...newSiemonPhases[siemonPhaseId],
      siemonValue: siemonValue,
    };

    const newValue = newSiemonPhases.reduce((acc, siemonPhase) => {
      return (acc += Number(siemonPhase.siemonValue ?? siemonPhase.maxPercent));
    }, 0);

    updateValidationOnChange(
      key,
      Math.round(100 * newValue) / 100,
      newSiemonPhases
    );
  }

  function handleToggleOpen() {
    setOpen(!open);
  }

  return (
    <Box className=" px-2 py-1 ">
      <Box className="flex items-center gap-3 justify-between">
        {phase?.siemon && showSiemon && !isCrossed ? (
          <IconButton onClick={() => handleToggleOpen()}>
            {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
          </IconButton>
        ) : (
          <Box className="w-[58.5px]" />
        )}
        <Typography
          className="w-full overflow-hidden"
          onClick={() => {
            togglePhase(`${phaseNumber}_phase%`, !isCrossed);
            if (!isCrossed) setOpen(false);
            setIsCrossed(!isCrossed);
          }}
          sx={{
            cursor: 'pointer',
            textDecoration: isCrossed ? 'line-through' : 'none',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            paddingY: '8px',
            paddingX: '8px',
            borderRadius: '10px',
            border: `1px solid transparent`,
            ':hover': {
              bgcolor: colors.info + '20',
              border: `1px solid ${colors.info}80`,
            },
          }}
        >
          {phaseNumber + 1 + '. ' + phase.title}
        </Typography>

        <Box className="flex items-center justify-between gap-5">
          <Typography
            color={colors.grey[600]}
            fontSize={12}
            sx={{ width: '70px', minWidth: '70px' }}
            className="hidden md:block"
          >
            {'max: ' + phase.maxPercent + '%'}
          </Typography>
          <Typography
            className="flex items-center"
            sx={{ width: '100px', minWidth: '100px' }}
          >
            {phase?.siemon && showSiemon && !isCrossed ? (
              <Typography
                fontSize={16}
                className="w-full text-right pr-3"
              >{`${dataCollection[key]} %`}</Typography>
            ) : (
              <TypeNumber
                dataCollection={dataCollection}
                updateValidationOnChange={handleChange}
                errors={{}}
                field={{
                  label: '',
                  key: [key],
                  unit: '%',
                }}
                size="small"
              />
            )}
          </Typography>
          <Typography
            className="text-right pr-1"
            sx={{ width: '125px', minWidth: '125px' }}
          >
            <MoneyLabel money={isCrossed ? 0 : phaseHonorarium || 0} />
          </Typography>
        </Box>
      </Box>
      <Collapse in={open && showSiemon}>
        {open &&
          showSiemon &&
          phase.siemon.map((siemonPhase, index) => (
            <SiemonPhase
              key={phaseNumber + index}
              siemonIndex={index}
              siemonPhase={siemonPhase}
              baseHonorarium={baseHonorarium}
              onChange={handleSiemonChange}
            />
          ))}
      </Collapse>
    </Box>
  );
};

const SiemonPhase = ({
  siemonPhase,
  siemonIndex,
  baseHonorarium,
  onChange,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const key = siemonIndex + '_siemonPhase';

  const [dataCollection, setDataCollection] = useState({
    [key]: siemonPhase.siemonValue ?? siemonPhase.maxPercent,
  });

  const value = siemonPhase.siemonValue ?? siemonPhase.maxPercent;
  const siemonPhaseHonorarium =
    Math.round((100 * baseHonorarium * Number(value)) / 100) / 100;

  function handleChange(key, value) {
    onChange(key, value);
  }

  return (
    <Box
      className="flex justify-between items-center py-[2px] pl-[100px]"
      sx={{
        ':hover': {
          bgcolor: colors.selected,
        },
      }}
    >
      <Typography>{siemonPhase.title}</Typography>

      <Box className="flex items-center justify-between gap-5">
        <Typography
          color={colors.grey[600]}
          fontSize={12}
          sx={{ width: '70px', minWidth: '70px' }}
          className="hidden md:block"
        >
          {'max: ' + siemonPhase.maxPercent + '%'}
        </Typography>
        <Typography
          className="flex items-center"
          sx={{ width: '100px', minWidth: '100px' }}
        >
          <TypeNumber
            dataCollection={dataCollection}
            updateValidationOnChange={handleChange}
            errors={{}}
            field={{
              label: '',
              key: [key],
              unit: '%',
            }}
            size="small"
          />
        </Typography>
        <Typography
          className="text-right pr-1"
          sx={{ width: '125px', minWidth: '125px' }}
        >
          <MoneyLabel money={siemonPhaseHonorarium || 0} />
        </Typography>
      </Box>
    </Box>
  );
};

export default HOAIPhase;
